export enum NotificationType {
  SUPPLIER_SHIPPING_BATCH_STATUS_CHANGE = "SUPPLIER_SHIPPING_BATCH_STATUS_CHANGE",
  BUYER_SHIPPING_BATCH_STATUS_CHANGE = "BUYER_SHIPPING_BATCH_STATUS_CHANGE",
  ADMIN_NEW_USER_FOR_APPROVAL = "ADMIN_NEW_USER_FOR_APPROVAL",
  NEW_USER_INVITATION = "NEW_USER_INVITATION",
  EXISTING_USER_INVITATION = "EXISTING_USER_INVITATION",
  ACCEPT_INVITATION = "ACCEPT_INVITATION",
  NEW_USER_PENDING_APPROVAL = "NEW_USER_PENDING_APPROVAL",
}
